export const marketingUrl =
  process.env.MARKETING_URL || 'https://flicket.co.nz';
